
export class DiscountSearchModel {
    keyword: string = "";
    isVisible: boolean = null;
    discountType: number = null;
    discountPermission: number = null;
    pageNum: number = 1;
    pageSize: number = 10;
}
